module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Bold.b078fcd.woff";